import { useNavigate, useLocation, useParams } from "react-router-dom";
import styles from "../styles/Language.module.css";

export default function LanguageSwitcher() {
  const navigate = useNavigate();
  const location = useLocation();
  const { lang } = useParams();

  const changeLang = (newLang) => {
    const path = location.pathname;

    // Split path → ["", "en", "contact"]
    const parts = path.split("/");

    // If no lang present (edge case)
    if (!parts[1]) {
      navigate(`/${newLang}`);
      return;
    }

    // Replace current lang
    parts[1] = newLang;

    const newPath = parts.join("/");

    navigate(newPath);
  };

  return (
    <div className={styles.container}>
      {["en", "de", "el", "fr", "it", "ru"].map((lng) => (
        <button
          key={lng}
          onClick={() => changeLang(lng)}
          className={`${styles.button} ${
            lang === lng ? styles.active : ""
          }`}
        >
          {lng.toUpperCase()}
        </button>
      ))}
    </div>
  );
}